module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-overlay', {
    attrs: {
      "show": _vm.load
    }
  }, [_c('b-card', {
    staticClass: "mb-2",
    class: {
      'invoice-cancelled-card': _vm.invoiceCancelled || _vm.invoiceInvalid || _vm.invoiceReportedInvalid, 'invoice-settled-card': _vm.invoiceSettled, 'invoice-partially-settled-card': _vm.invoicePartiallySettled, 'invoice-assigned-card': _vm.invoiceAssignedTo
    },
    attrs: {
      "header-text-variant": "dark",
      "border-variant": _vm.invoiceCancelled || _vm.invoiceInvalid ? 'danger' : null,
      "header-border-variant": _vm.invoiceCancelled || _vm.invoiceInvalid ? 'danger' : null
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('invoices.invoiceDetails'),
      "alternativeRoute": "invoices/invoice-information"
    },
    scopedSlots: _vm._u([{
      key: "badges",
      fn: function(props) {
        return [_c('span', [(_vm.invoiceCancelled) ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceCancelled')))]) : _vm._e(), _vm._v(" "), (_vm.invoiceInvalid) ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceInvalid')))]) : _vm._e(), _vm._v(" "), (_vm.invoiceSettled) ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceSettled')))]) : _vm._e(), _vm._v(" "), (_vm.invoiceAssignedTo) ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceAssigned')))]) : _vm._e(), _vm._v(" "), (_vm.invoicePartiallySettled) ? _c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoicePartiallySettled')))]) : _vm._e(), _vm._v(" "), (_vm.invoiceActive) ? _c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceActive')))]) : _vm._e(), _vm._v(" "), (_vm.invoiceReportedInvalid) ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceReportedInvalid')))]) : _vm._e()], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceId')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoiceId))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('issues.reportIssues')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [(_vm.reportedActiveIssues) ? _c('b-link', {
    staticClass: "property-label",
    attrs: {
      "to": '/reported-issues?resourceId=' + _vm.invoiceId + '&status=1'
    }
  }, [_vm._v(_vm._s(_vm.$t('issues.reportIssuesActive')) + ": " + _vm._s(_vm.reportedActiveIssues))]) : _c('span', [_vm._v(_vm._s(_vm.$t('issues.reportIssuesActive')) + ": " + _vm._s(_vm.reportedActiveIssues))]), _vm._v("\r\n                           \r\n                        "), (_vm.reportedIssues) ? _c('b-link', {
    staticClass: "property-label",
    attrs: {
      "to": '/reported-issues?resourceId=' + _vm.invoiceId
    }
  }, [_vm._v(_vm._s(_vm.$t('issues.reportIssuesAll')) + ": " + _vm._s(_vm.reportedIssues))]) : _c('span', [_vm._v(_vm._s(_vm.$t('issues.reportIssuesAll')) + ": " + _vm._s(_vm.reportedIssues))])], 1)])], 1), _vm._v(" "), (_vm.canReportIssue) ? _c('b-col', [_c('b-img', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "report-image",
    attrs: {
      "title": _vm.$t('general.technicalSupport'),
      "right": "",
      "src": require("@/assets/images/report-issue.svg")
    },
    on: {
      "click": _vm.reportLiabilityIssue
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('hr', {
    staticClass: "mt-0"
  }), _vm._v(" "), _c('b-row', [(_vm.isCurrentUserAdmin && _vm.invoice.debtorId) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnDebtorName')
    }
  }, [_c('b-link', {
    staticClass: "property-label",
    attrs: {
      "to": _vm.debtorLink
    }
  }, [_vm._v(_vm._s(_vm.invoice.debtorName))])], 1)], 1) : _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnDebtorName')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.debtorName))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnBudgetIdNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.debtorCompanyNumber))])])], 1)], 1), _vm._v(" "), _c('b-row', [(_vm.isCurrentUserAdmin && _vm.invoice.creditorId) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnCreditorName')
    }
  }, [_c('b-link', {
    staticClass: "property-label",
    attrs: {
      "to": _vm.creditorLink
    }
  }, [_vm._v(_vm._s(_vm.invoice.creditorName))])], 1)], 1) : _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnCreditorName')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.creditorName))])])], 1), _vm._v(" "), (_vm.invoice.isPublicCreditor) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnCreditorBudgetIdNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.creditorCompanyNumber))])])], 1) : _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnCreditorCompanyNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.creditorCompanyNumber))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnCreditorTaxId')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.creditorTaxIdNumber))])])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnInvoiceNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.invoiceNumber))])])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnInvoiceAmount')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatAmount(_vm.invoice.amount)))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnSettledAmount')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatAmount(_vm.invoice.settledAmount)))])])], 1), _vm._v(" "), (_vm.hasInvoiceSettlements && _vm.lastActiveSettlement) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnSettlementDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.lastActiveSettlement)))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnCreationDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.invoice.creationDate)))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('registerInvoice.issueDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatShortDate(_vm.invoice.issueDate)))])])], 1), _vm._v(" "), (_vm.invoice.dueDate) ? _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.columnDueDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatShortDate(_vm.invoice.dueDate)))])])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.invoice.lifetime) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('registerInvoice.registerProinvoiceLifetime')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.lifetime))])])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.invoiceAssignedTo && _vm.invoice.comments) ? _c('div', [_c('hr'), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('registerInvoice.comments')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.comments))])])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.invoiceCancelled) ? _c('b-row', [_c('hr'), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.cancellationUser')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.cancelName))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.cancellationDate')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.formatDate(_vm.invoice.cancelDate)))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.cancellationComment')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.cancelComments))])])], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.invoiceEmpty()) ? _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-dropdown', {
    staticClass: "m-md-2",
    attrs: {
      "text": _vm.$t('invoices.invoiceExport'),
      "variant": "success",
      "split": "",
      "disabled": _vm.exportDisabled
    },
    on: {
      "click": function($event) {
        return _vm.exportToJson()
      }
    }
  }, [_c('b-dropdown-item-button', {
    on: {
      "click": function($event) {
        return _vm.exportToCsv()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceExportCsv')))]), _vm._v(" "), _c('b-dropdown-item-button', {
    on: {
      "click": function($event) {
        return _vm.exportToJson()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceExportJson')))]), _vm._v(" "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1), _vm._v(" "), (_vm.canCancelInvoice) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.cancelInvoiceModal",
      modifiers: {
        "cancelInvoiceModal": true
      }
    }],
    staticClass: "m-md-2",
    attrs: {
      "variant": "success",
      "disabled": _vm.cancelDisabled
    }
  }, [_vm._v("\r\n                " + _vm._s(_vm.$t('invoices.cancelInvoice')) + "\r\n                "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.invoiceEmpty()) ? _c('div', {
    attrs: {
      "role": "tablist"
    }
  }, [(!_vm.invoiceCancelled && !_vm.invoiceInvalid) ? _c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.invoiceSettlements",
      modifiers: {
        "invoiceSettlements": true
      }
    }],
    attrs: {
      "block": "",
      "href": "#",
      "variant": "secondary"
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.settlementDetails')) + " "), (_vm.settlements.length) ? _c('span', [_vm._v("(" + _vm._s(_vm.settlements.length) + ")")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!_vm.invoiceCancelled && !_vm.invoiceInvalid) ? _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "invoiceSettlements",
      "role": "tabpanel"
    },
    model: {
      value: (_vm.showCollapse.invoice_settlements),
      callback: function($$v) {
        _vm.$set(_vm.showCollapse, "invoice_settlements", $$v)
      },
      expression: "showCollapse.invoice_settlements"
    }
  }, [_c('b-card', {
    staticClass: "mb-3"
  }, [(_vm.canReportIssue) ? _c('div', {
    staticClass: "mb-5"
  }, [_c('b-img', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "report-image",
    attrs: {
      "title": _vm.$t('general.technicalSupport'),
      "right": "",
      "src": require("@/assets/images/report-issue.svg")
    },
    on: {
      "click": _vm.reportSettlementIssue
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('b-table', {
    attrs: {
      "fields": _vm.fields,
      "items": _vm.settlements
    },
    scopedSlots: _vm._u([{
      key: "cell(settledAmount)",
      fn: function(data) {
        return [_vm._v(_vm._s(_vm.formatAmount(data.item.settledAmount)))]
      }
    }, {
      key: "cell(settlementDate)",
      fn: function(data) {
        return [_vm._v(_vm._s(_vm.formatDate(data.item.settlementDate)))]
      }
    }, {
      key: "cell(settlementStatus)",
      fn: function(data) {
        return [(data.item.status === _vm.SettlementStatus.ACTIVE) ? _c('b-btn', {
          attrs: {
            "size": "sm",
            "variant": "success",
            "disabled": ""
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.settlementStatus.1')))]) : _c('b-btn', {
          attrs: {
            "variant": "danger",
            "size": "sm",
            "disabled": ""
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.settlementStatus.2')))])]
      }
    }, {
      key: "cell(settlementComments)",
      fn: function(data) {
        return [(data.item.cancelComments) ? _c('p', [_c('b', [_vm._v(_vm._s(_vm.$t('invoices.invoiceCancelledComment')))]), _vm._v(" " + _vm._s(data.item.cancelComments))]) : _c('p', [_vm._v(_vm._s(data.item.settlementComments))])]
      }
    }], null, false, 631755234)
  })], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.canAssignInvoice || _vm.canViewAssignement) ? _c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.invoiceAssignment",
      modifiers: {
        "invoiceAssignment": true
      }
    }],
    attrs: {
      "block": "",
      "href": "#",
      "variant": "secondary"
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceAssignment')))])], 1) : _vm._e(), _vm._v(" "), (_vm.canAssignInvoice || _vm.canViewAssignement) ? _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "invoiceAssignment",
      "role": "tabpanel"
    },
    model: {
      value: (_vm.showCollapse.invoiceAssignment),
      callback: function($$v) {
        _vm.$set(_vm.showCollapse, "invoiceAssignment", $$v)
      },
      expression: "showCollapse.invoiceAssignment"
    }
  }, [_c('b-card', {
    staticClass: "mb-3"
  }, [(_vm.canAssignInvoice) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('registerInvoice.debtorBudgetId')
    }
  }, [_c('autocomplete', {
    ref: "budgetIdAutocomplete",
    attrs: {
      "url": _vm.autoCompleteUrl_budgetId,
      "criteria": "budgetId",
      "description": "name"
    },
    model: {
      value: (_vm.invoice.DebtorCompanyNumber),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "DebtorCompanyNumber", $$v)
      },
      expression: "invoice.DebtorCompanyNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('invoices.invoiceAssignmentContractNumber')
    }
  }, [_c('b-form-input', {
    model: {
      value: (_vm.invoice.AssignmentContractNumber),
      callback: function($$v) {
        _vm.$set(_vm.invoice, "AssignmentContractNumber", $$v)
      },
      expression: "invoice.AssignmentContractNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.assignInvoiceModal",
      modifiers: {
        "assignInvoiceModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.assignDisabled
    }
  }, [_vm._v("\r\n                            " + _vm._s(_vm.$t('forms.apply')) + "\r\n                            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1), _vm._v(" "), (_vm.assignDisabled) ? _c('b-row', {
    staticClass: "text-right mt-2",
    attrs: {
      "align-h": "end",
      "align-v": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('p', {
    staticClass: "mb-0"
  }, [_c('small', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceAssignValidDebtorWarning') + _vm.invoice.debtorCompanyNumber))])])])], 1) : _vm._e()], 1)], 1) : (_vm.invoiceAssignedTo) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceAssignIdf')
    }
  }, [_c('b-link', {
    staticClass: "property-label",
    attrs: {
      "href": _vm.assignationLink
    }
  }, [_vm._v(_vm._s(_vm.invoice.comments))])], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceAssignedName')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.assignedDebtorName))])])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [(_vm.isPublicEntity) ? _c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceAssignedBudgetNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.assignedDebtorCompanyNumber))])]) : _vm._e(), _vm._v(" "), (_vm.isPrivateEntity) ? _c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceAssignedCompanyNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.assignedDebtorCompanyNumber))])]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [(_vm.isPrivateEntity) ? _c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceAssignedTaxIdNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.assignedDebtorTaxIdNumber))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceAssignmentContractNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.assignmentContractNumber))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(!_vm.invoiceCancelled && !_vm.invoiceInvalid) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.cancelAssignInvoiceModal",
      modifiers: {
        "cancelAssignInvoiceModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.assignDisabled
    }
  }, [_vm._v("\r\n                            " + _vm._s(_vm.$t('invoices.invoiceAssignCancel')) + "\r\n                            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1) : _vm._e()], 1)], 1) : (_vm.invoiceAssignedFrom) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceAssignOriginIdf')
    }
  }, [_c('b-link', {
    staticClass: "property-label",
    attrs: {
      "href": _vm.invoiceLink
    }
  }, [_vm._v(_vm._s(_vm.invoice.assignedInvoiceId))])], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceAssignmentContractNumber')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoice.assignmentContractNumber))])])], 1)], 1)], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!_vm.invoiceCancelled && !_vm.invoiceInvalid) ? _c('b-card-header', {
    staticClass: "p-1",
    attrs: {
      "header-tag": "header",
      "role": "tab"
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.amountChange",
      modifiers: {
        "amountChange": true
      }
    }],
    attrs: {
      "block": "",
      "href": "#",
      "variant": "secondary"
    }
  }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceAmountChange')) + "  "), (_vm.invoiceDeltas.length) ? _c('span', [_vm._v("(" + _vm._s(_vm.invoiceDeltas.length) + ")")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "amountChange",
      "role": "tabpanel"
    },
    model: {
      value: (_vm.showCollapse.amountChange),
      callback: function($$v) {
        _vm.$set(_vm.showCollapse, "amountChange", $$v)
      },
      expression: "showCollapse.amountChange"
    }
  }, [_c('b-card', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('b-table', {
    attrs: {
      "fields": _vm.deltaFields,
      "items": _vm.invoiceDeltas
    },
    scopedSlots: _vm._u([{
      key: "cell(amount)",
      fn: function(data) {
        return [_vm._v(_vm._s(_vm.formatAmount(data.item.amount)))]
      }
    }, {
      key: "cell(creationDate)",
      fn: function(data) {
        return [_vm._v(_vm._s(data.item.status === _vm.DeltaStatus.ACTIVE || data.item.status === _vm.DeltaStatus.ACTIVATION ? _vm.formatDate(data.item.creationDate) : _vm.formatDate(data.item.cancelDate)))]
      }
    }, {
      key: "cell(comments)",
      fn: function(data) {
        return [_vm._v(_vm._s(data.item.status === _vm.DeltaStatus.ACTIVE || data.item.status === _vm.DeltaStatus.ACTIVATION ? data.item.comments : data.item.cancelComments))]
      }
    }, {
      key: "cell(previousDueDate)",
      fn: function(data) {
        return [_vm._v(_vm._s(data.item.previousDueDate ? _vm.formatShortDate(data.item.previousDueDate) : "-"))]
      }
    }, {
      key: "cell(cancelSlot)",
      fn: function(data) {
        return [(data.item.status === _vm.DeltaStatus.ACTIVE) ? _c('b-btn', {
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.cancelInvoiceDeltaSelected(data.item.id, data.item.amount)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceDeltaCancel')))]) : (data.item.status === _vm.DeltaStatus.ACTIVATION) ? _c('b-btn', {
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.cancelInvoiceDeltaSelected(data.item.id, data.item.amount)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceActivationCancel')))]) : _c('b-btn', {
          attrs: {
            "variant": "danger",
            "size": "sm",
            "disabled": ""
          }
        }, [_vm._v(_vm._s(_vm.$t('invoices.invoiceCancelled')))])]
      }
    }], null, false, 1181245811)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.addAmountChangeModal",
      modifiers: {
        "addAmountChangeModal": true
      }
    }],
    attrs: {
      "variant": "success",
      "disabled": _vm.invoiceSettled && !_vm.canActivateInvoice
    }
  }, [_vm._v("\r\n                        " + _vm._s(_vm.$t('invoices.invoiceAmountChangeAdd')) + "\r\n                    ")])], 1)])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "cancelInvoiceModal",
      "title": _vm.$t('invoices.cancelInvoice'),
      "ok-title": _vm.$t('forms.apply'),
      "ok-only": ""
    },
    on: {
      "ok": _vm.cancelInvoice
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cancelInvoice($event)
      }
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoice.cancelComments),
      expression: "invoice.cancelComments"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "type": "text",
      "placeholder": _vm.$t('invoices.cancellationComment')
    },
    domProps: {
      "value": (_vm.invoice.cancelComments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoice, "cancelComments", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('b-modal', {
    ref: "cancelSettlementModal",
    attrs: {
      "title": _vm.$t('invoices.cancelSettlement')
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function() {
        return [_c('b-button', {
          staticClass: "mt-3",
          attrs: {
            "disabled": _vm.invoiceSettlement.cancelComments === null
          },
          on: {
            "click": _vm.cancelSettlement
          }
        }, [_vm._v(_vm._s(_vm.$t('forms.apply')))])]
      },
      proxy: true
    }])
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceSettlement.cancelComments),
      expression: "invoiceSettlement.cancelComments"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "type": "text",
      "placeholder": _vm.$t('invoices.cancellationComment')
    },
    domProps: {
      "value": (_vm.invoiceSettlement.cancelComments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceSettlement, "cancelComments", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "settleInvoiceModal",
      "title": _vm.$t('invoices.settleInvoice'),
      "ok-title": _vm.$t('forms.apply'),
      "ok-only": ""
    },
    on: {
      "ok": _vm.validateBeforeSettle
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    staticClass: "property-label-caption",
    attrs: {
      "label": _vm.$t('invoices.invoiceId')
    }
  }, [_c('label', {
    staticClass: "property-label"
  }, [_vm._v(_vm._s(_vm.invoiceId))])])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('invoices.bank')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.invoiceSettlement.Bank.$error
    },
    attrs: {
      "name": "invoiceSettlement.Bank",
      "maxlength": "3"
    },
    model: {
      value: (_vm.invoiceSettlement.Bank),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "Bank", $$v)
      },
      expression: "invoiceSettlement.Bank"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('invoices.columnSettlementDate')
    }
  }, [_c('datepicker', {
    attrs: {
      "name": "invoiceSettlement.SettlementDate",
      "language": _vm.dateLocale,
      "placeholder": _vm.dateFormat,
      "format": _vm.customFormatter,
      "inputFormat": _vm.inputFormat,
      "typeable": true,
      "clear-button": "",
      "input-class": {
        'form-control': true,
        'error': _vm.$v.invoiceSettlement.SettlementDate.$error && !_vm.invoiceSettlement.SettlementDate
      }
    },
    model: {
      value: (_vm.invoiceSettlement.SettlementDate),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "SettlementDate", $$v)
      },
      expression: "invoiceSettlement.SettlementDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('invoices.settlementPaymentId')
    }
  }, [_c('b-form-input', {
    class: {
      'error': _vm.$v.invoiceSettlement.ExternalId.$error
    },
    attrs: {
      "name": "invoiceSettlement.ExternalId"
    },
    model: {
      value: (_vm.invoiceSettlement.ExternalId),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "ExternalId", $$v)
      },
      expression: "invoiceSettlement.ExternalId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('invoices.settlementAmount')
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.$t('invoices.invoiceCurrency')
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    class: {
      'error': _vm.$v.invoiceSettlement.SettledAmount.$error
    },
    attrs: {
      "name": "invoiceSettlement.SettledAmount"
    },
    model: {
      value: (_vm.invoiceSettlement.SettledAmount),
      callback: function($$v) {
        _vm.$set(_vm.invoiceSettlement, "SettledAmount", $$v)
      },
      expression: "invoiceSettlement.SettledAmount"
    }
  }, 'money', _vm.currency, false))], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "assignInvoiceModal",
      "title": _vm.$t('invoices.invoiceAssignment'),
      "ok-title": _vm.$t('forms.apply'),
      "cancel-title": _vm.$t('forms.close')
    },
    on: {
      "ok": _vm.assignInvoice
    }
  }, [_vm._v("\r\n        " + _vm._s(_vm.$t('invoices.invoiceAssignmentModal')) + "\r\n    ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "cancelAssignInvoiceModal",
      "title": _vm.$t('invoices.invoiceAssignment'),
      "ok-title": _vm.$t('forms.apply'),
      "cancel-title": _vm.$t('forms.close')
    },
    on: {
      "ok": _vm.cancelInvoiceAssign
    }
  }, [_vm._v("\r\n        " + _vm._s(_vm.$t('invoices.invoiceAssignmentCancelModal')) + "\r\n    ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "addAmountChangeModal",
      "title": _vm.$t('invoices.invoiceAmountChangeAdd'),
      "ok-only": "",
      "ok-title": _vm.$t('forms.apply'),
      "cancel-title": _vm.$t('forms.close')
    },
    on: {
      "ok": _vm.addInvoiceAmountDelta
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('registerInvoice.amount')
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.$t('invoices.invoiceCurrency')
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "name": "invoiceDelta.amount"
    },
    model: {
      value: (_vm.invoiceDelta.amount),
      callback: function($$v) {
        _vm.$set(_vm.invoiceDelta, "amount", $$v)
      },
      expression: "invoiceDelta.amount"
    }
  }, 'money', _vm.currency, false))], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4",
      "align-self": "center"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settlementDeltaSelected),
      expression: "settlementDeltaSelected"
    }],
    staticClass: "settle-input",
    attrs: {
      "type": "checkbox",
      "v": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.settlementDeltaSelected) ? _vm._i(_vm.settlementDeltaSelected, null) > -1 : (_vm.settlementDeltaSelected)
    },
    on: {
      "click": _vm.calculateSettlementsDelta,
      "change": [function($event) {
        var $$a = _vm.settlementDeltaSelected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.settlementDeltaSelected = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.settlementDeltaSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.settlementDeltaSelected = $$c
        }
      }, _vm.calculateSettlementsDeltaChange]
    }
  }), _vm._v(_vm._s(_vm.$t('invoices.invoiceAmountChangeSettle')))])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('invoices.invoiceAmountChangeComment')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceDelta.comments),
      expression: "invoiceDelta.comments"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "2",
      "name": "invoiceDelta.comments"
    },
    domProps: {
      "value": (_vm.invoiceDelta.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceDelta, "comments", $event.target.value)
      }
    }
  })])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "cancelInvoiceDeltaModal",
    attrs: {
      "title": _vm.$t('invoices.invoiceDeltaCancel'),
      "ok-title": _vm.$t('forms.apply'),
      "ok-only": ""
    },
    on: {
      "ok": _vm.cancelInvoiceAmountDelta
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.cancelInvoiceAmountDelta($event)
      }
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoiceDelta.cancelComments),
      expression: "invoiceDelta.cancelComments"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5",
      "placeholder": _vm.$t('invoices.cancellationComment')
    },
    domProps: {
      "value": (_vm.invoiceDelta.cancelComments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.invoiceDelta, "cancelComments", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('b-modal', {
    ref: "reportIssueModal",
    attrs: {
      "title": _vm.currentIssue === this.IssueCategory[0] ? _vm.$t('issues.reportIssueLiability') : _vm.$t('issues.reportIssueSettlement'),
      "header-bg-variant": "warning",
      "ok-title": _vm.$t('forms.send'),
      "size": "lg",
      "ok-only": ""
    },
    on: {
      "ok": _vm.submitIssueReport
    }
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportId')
    }
  }, [_c('b-form-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.currentIssueReport.resourceId),
      callback: function($$v) {
        _vm.$set(_vm.currentIssueReport, "resourceId", $$v)
      },
      expression: "currentIssueReport.resourceId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportCategories')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.formattedIssueCategories
    },
    on: {
      "input": _vm.categoryChanged
    },
    model: {
      value: (_vm.selectedCategory),
      callback: function($$v) {
        _vm.selectedCategory = $$v
      },
      expression: "selectedCategory"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.currentIssueCategory && _vm.currentIssueCategory.requiresData) ? _c('div', [(_vm.currentIssue.ID === _vm.IssueCategory[1].ID && _vm.currentIssueCategory.id === 3) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportSettlementAmount')
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.$t('invoices.invoiceCurrency')
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "name": "issues.amount"
    },
    model: {
      value: (_vm.currentIssueAmount),
      callback: function($$v) {
        _vm.currentIssueAmount = $$v
      },
      expression: "currentIssueAmount"
    }
  }, 'money', _vm.currency, false))], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentIssue.ID === _vm.IssueCategory[1].ID && _vm.currentIssueCategory.id === 4 && _vm.hasInvoiceSettlements) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportSettlementId')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.invoiceSettlementIDs
    },
    model: {
      value: (_vm.currentIssueSettlementId),
      callback: function($$v) {
        _vm.currentIssueSettlementId = $$v
      },
      expression: "currentIssueSettlementId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportSettlementAmount')
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": _vm.$t('invoices.invoiceCurrency')
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "name": "issues.amount"
    },
    model: {
      value: (_vm.currentIssueAmount),
      callback: function($$v) {
        _vm.currentIssueAmount = $$v
      },
      expression: "currentIssueAmount"
    }
  }, 'money', _vm.currency, false))], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentIssue.ID === _vm.IssueCategory[0].ID && _vm.currentIssueCategory.id === 1) ? _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportData')
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.invoiceFields,
      "state": false
    },
    model: {
      value: (_vm.currentIssueReport.data),
      callback: function($$v) {
        _vm.$set(_vm.currentIssueReport, "data", $$v)
      },
      expression: "currentIssueReport.data"
    }
  })], 1)], 1)], 1) : _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportData')
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": false
    },
    model: {
      value: (_vm.currentIssueReport.data),
      callback: function($$v) {
        _vm.$set(_vm.currentIssueReport, "data", $$v)
      },
      expression: "currentIssueReport.data"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "field-description"
  }, [_vm._v(_vm._s(_vm.currentIssueCategory.dataDescriptionCyr))])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('issues.reportUserComment')
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentIssueReport.userComment),
      expression: "currentIssueReport.userComment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "type": "text"
    },
    domProps: {
      "value": (_vm.currentIssueReport.userComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.currentIssueReport, "userComment", $event.target.value)
      }
    }
  })])], 1)], 1), _vm._v(" "), (_vm.currentIssueCategory && _vm.currentIssueCategory.categoryHelp) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "col": "",
      "md": "12"
    }
  }, [_c('b-card', {
    attrs: {
      "bg-variant": "danger",
      "text-variant": "white"
    }
  }, [_c('p', {
    staticClass: "card-text"
  }, [_vm._v(_vm._s(_vm.currentIssueCategory.categoryDescriptionCyr))]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#fa9a4b"
    },
    attrs: {
      "href": _vm.helpLink(_vm.currentIssueCategory.categoryHelp),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('issues.reportIssueHelpLink')))])])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-751ffc9f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./src/components/home/invoices/single-invoice/single-invoice.html
// module id = 774
// module chunks = 1